<div>
	<schir-int-client-checkboxes
		legend="Bescheinigungsart"
		errorText="Bitte Bescheinigungsart wählen"
		[values]="bescheinigungsarten"
		[labels]="aufgabeTypLabel"
		[control]="formGroup.controls.bescheinigungsart" />
	<mat-form-field appearance="outline">
		<mat-label>Notiz zur Aufgabe</mat-label>
		<textarea matInput [formControl]="formGroup.controls.notiz"></textarea>
	</mat-form-field>
</div>
<div>
	<mat-radio-group color="primary" [formControl]="formGroup.controls.versandTaetigkeit">
		@for (taetigkeit of versandTaetigkeiten; track taetigkeit) {
			<mat-radio-button [value]="taetigkeit">
				{{ taetigkeit | enumToLabel: versandTaetigkeitLabel }}
			</mat-radio-button>
		}
	</mat-radio-group>
	<schir-int-client-checkboxes
		legend="Empfänger"
		errorText="Bitte Empfänger wählen"
		[values]="kontaktKategorien"
		[labels]="kontaktKategorieLabel"
		[control]="formGroup.controls.empfaenger" />
	<mat-checkbox
		color="primary"
		[formControl]="formGroup.controls.vorabPerFax"
		(change)="toggleFaxEmpfaengerControl($event.checked)"
		data-test-id="vorab-per-fax">
		vorab per Fax
	</mat-checkbox>
	@if (formGroup.controls.faxEmpfaenger.enabled) {
		<schir-int-client-checkboxes
			legend="Fax-Empfänger"
			errorText="Bitte Fax-Empfänger wählen"
			[values]="kontaktKategorien"
			[labels]="kontaktKategorieLabel"
			[control]="formGroup.controls.faxEmpfaenger"
			data-test-id="fax-empfaenger" />
	}
</div>
